<ul class="breadcrumbs">
  <li class="breadcrumb-item"
      *ngFor="let item of items">
    <a class="breadcrumb-link"
       [href]="[item.href]"
       [translate]="item.label"></a>
  </li>
</ul>
